// extracted by mini-css-extract-plugin
export var container = "_63-0";
export var disabled = "_63-4";
export var fullWidth = "_63-3";
export var lined = "_63-1";
export var selected = "_63-5";
export var tab = "_63-2";